import { createContext } from 'react'

import type { HugTableContextValue } from '@/components/lemmala-design-system/table/types'

export const HugTableContext = createContext<HugTableContextValue>({
  isInHugContainer: false,
  availableHeight: null,
})
